import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Car: React.FC<SvgProps> = (props) => {
  return (
    <Icon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        d="M19.2891 10.5H20.25V12H19.5V18.75L18.75 19.5H15.75L15 18.75V17.7002H9V18.75L8.25 19.5H5.25L4.5 18.75V12H3.75V10.5H4.71094L7.31641 5.25H16.6836L19.2891 10.5ZM6 12V18H7.5V16.9502L8.25 16.2002H15.75L16.5 16.9502V18H18V12H6ZM8.625 12.75C9.24632 12.75 9.75 13.2537 9.75 13.875C9.75 14.4963 9.24632 15 8.625 15C8.00368 15 7.5 14.4963 7.5 13.875C7.5 13.2537 8.00368 12.75 8.625 12.75ZM15.375 12.75C15.9963 12.75 16.5 13.2537 16.5 13.875C16.5 14.4963 15.9963 15 15.375 15C14.7537 15 14.25 14.4963 14.25 13.875C14.25 13.2537 14.7537 12.75 15.375 12.75ZM6.38477 10.5H17.6152L15.7539 6.75H8.24609L6.38477 10.5Z"
        fill="#currentColor"
      />
    </Icon>
  )
}
